import { c as _c } from "react-compiler-runtime";
import React from 'react';
import { Skeleton } from '@nike/nike-design-system-components';
import useFetchWebShellProduct from '@nike/shop-apis/web-shell-client/product/use-query';
import useFetchCart from '@nike/shop-apis/buy/carts/v2/fetch/use-query';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import ProductAttribute from "../../product-attribute";
import useItemAddedModalStore from "../../../store/item-added-modal/use-store";
var CartItemAddedModalProductSize = function CartItemAddedModalProductSize() {
  var $ = _c(18);
  var itemId_0 = useItemAddedModalStore(_temp);
  var productCode_0 = useItemAddedModalStore(_temp2);
  var t0;
  if ($[0] !== itemId_0) {
    t0 = {
      select: function select(cart) {
        var _cart$items;
        var item_0 = cart === null || cart === void 0 || (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items.find(function (item) {
          return item.id === itemId_0;
        });
        if (!item_0) {
          return {};
        }
        var skuId = item_0.skuId,
          giftCard = item_0.giftCard;
        return {
          skuId: skuId,
          giftCard: giftCard
        };
      }
    };
    $[0] = itemId_0;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  var _useFetchCart = useFetchCart(t0),
    t1 = _useFetchCart.data;
  var t2;
  if ($[2] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  var _t = t2,
    skuId_0 = _t.skuId,
    giftCard_0 = _t.giftCard;
  var t3;
  if ($[4] !== skuId_0) {
    t3 = function t3(product) {
      var _sizes$;
      var sizes = (product === null || product === void 0 ? void 0 : product.sizes) || [];
      return {
        matchedSize: sizes.find(function (size) {
          return size.merchSkuId === skuId_0;
        }),
        isOneSize: sizes.length === 1 && ((_sizes$ = sizes[0]) === null || _sizes$ === void 0 ? void 0 : _sizes$.label) === "ONE SIZE"
      };
    };
    $[4] = skuId_0;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  var t4;
  if ($[6] !== productCode_0 || $[7] !== t3) {
    t4 = {
      productCode: productCode_0,
      select: t3
    };
    $[6] = productCode_0;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  var _useFetchWebShellProd = useFetchWebShellProduct(t4),
    t5 = _useFetchWebShellProd.data,
    isLoading = _useFetchWebShellProd.isLoading;
  var t6;
  if ($[9] !== t5) {
    t6 = t5 === undefined ? {} : t5;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  var _t2 = t6,
    matchedSize = _t2.matchedSize,
    isOneSize = _t2.isOneSize;
  var t7;
  if ($[11] === Symbol["for"]("react.memo_cache_sentinel")) {
    t7 = {
      stringKey: "one.size",
      primaryValue: "One Size",
      description: "One size label"
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  var oneSizeString = useI18nString(t7);
  var t8;
  if ($[12] === Symbol["for"]("react.memo_cache_sentinel")) {
    t8 = {
      stringKey: "product.sizeLabel",
      primaryValue: "Size",
      description: "Header text representing 'size' of apparel or shoe."
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  var sizeString = useI18nString(t8);
  if (giftCard_0) {
    return null;
  }
  if (isLoading) {
    var _t3;
    if ($[13] === Symbol["for"]("react.memo_cache_sentinel")) {
      _t3 = /*#__PURE__*/React.createElement(Skeleton, {
        height: "16px",
        width: "50%",
        style: {
          margin: "6px 0 6px"
        }
      });
      $[13] = _t3;
    } else {
      _t3 = $[13];
    }
    return _t3;
  }
  if (isOneSize) {
    var _t4;
    if ($[14] !== oneSizeString) {
      _t4 = /*#__PURE__*/React.createElement(ProductAttribute, null, oneSizeString);
      $[14] = oneSizeString;
      $[15] = _t4;
    } else {
      _t4 = $[15];
    }
    return _t4;
  }
  var sizeTranslation = skuId_0 ? sizeString : null;
  var label = matchedSize === null || matchedSize === void 0 ? void 0 : matchedSize.localizedLabel;
  var t9 = "".concat(sizeTranslation, " ").concat(label);
  var t10;
  if ($[16] !== t9) {
    t10 = /*#__PURE__*/React.createElement(ProductAttribute, null, t9);
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
export default CartItemAddedModalProductSize;
function _temp(t0) {
  var itemId = t0.itemId;
  return itemId;
}
function _temp2(t0) {
  var productCode = t0.productCode;
  return productCode;
}